import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const FiltersTableBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Фильтры',
        url: '',
    },
]);
